import React, { Component } from "react";
import RenderTable from "../common/table";
import { Icon, Label } from "semantic-ui-react";
import auth from "../../services/authService";

class LedgerTypesTable extends Component {
  columns = [
    {
      path: "name",
      label: "Name",
      width: "12"
    },
    {
      path: "status",
      label: "Status",
      width: "2",
      content: type =>
        type.status == 1 ? (
          <Label color="green">Active</Label>
        ) : (
            <Label color="yellow">InActive</Label>
          )
    },
    {
      key: "actions",
      width: "2",
      content: type =>
        auth.getCurrentUser().email === "client-unblocker@gondalgroup.ae" && (
          <div>
            <Icon
              name={type.status == 1 ? "hide" : "eye"}
              color={type.status == 1 ? "black" : "green"}
              className="clickable"
              onClick={() => this.props.onStatusUpdate(type)}
            />
            <Icon
              name="trash"
              color="red"
              className="clickable"
              onClick={() => this.props.onDelete(type)}
            />

            <Icon
              name="edit"
              color="blue"
              className="clickable"
              onClick={() => this.props.onUpdate(type)}
            />
          </div>
        )
    }
  ];

  render() {
    const { types, onSort, sortColumn } = this.props;

    return (
      <RenderTable
        columns={this.columns}
        data={types}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default LedgerTypesTable;
